module.exports = __webpack_public_path__ + "static/media/messenger-onsurance.509e33e4.png";